export default {
    "filterAvatars_loading": "Loading more drivers...",
    "filterAvatars_search_drivers": "Search drivers"
}